import { getCartList, addCart, updateCart, delCart, clearCart } from "@/request/api"; // 你自己的 axios 封装
const state = {
  cart: [],
};

const mutations = {
  SET_CART(state, cart) {
    state.cart = cart || [];
  },
};

const actions = {
  /** 获取购物车 */
  async fetchCart({ commit }) {
    const res = await getCartList();
    commit("SET_CART", res.result.data);
  },

  /** 添加购物车 */
  async addToCart({ dispatch }, { bookId, number = 1 }) {
    const res = await addCart({ bookId, number });
    if (!res || res.resultCode != 0) {
      throw new Error((res && res.errorMsg) || "加入购物车失败");
    }
    // 接口成功后重新拉取
    dispatch("fetchCart");
  },

  /** 修改数量 */
  async updateCartItem({ dispatch }, {id, bookId, number }) {
    await updateCart({id, bookId, number });
    dispatch("fetchCart");
  },

  /** 删除 */
  async removeFromCart({ dispatch }, id) {
    console.log(id);
    let url="&id="+id;
    const res = await delCart(url,{}); // axios 调接口
    console.log(res);


    // 判断接口返回的 resultCode
    if (!res || res.resultCode !== 0) {
      // 这里用 res.errorMsg
      throw new Error(res.errorMsg || "删除购物车失败");
    }

    dispatch("fetchCart");
  },

  /** 清空 */
  async clearCart({ dispatch }) {
    await clearCart();
    dispatch("fetchCart");
  },
};

const getters = {
  cartCount: (state) => state.cart.reduce((total, item) => total + item.number, 0),

  cartTotalPrice: (state) => state.cart.reduce((total, item) => total + item.price * item.number, 0),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/cart.js